import { HarvestTypes } from "@gtpl/shared-models/common-models";

export class BatchNumRequest {
    batchNum:string;
   
}

export class LotNumRequest {
    lotNum:string[];
}

export class RmCountRequest {
    count1:number;
    count2:number;
    date?:string
    harvestType?:HarvestTypes

}

export class getMonthWisePurchaseRequest{
    // month:string;
    fromDate?:string
    toDate?:string
    unit?:number
}